import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, TextField, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";

function SharePopup({ open, onClose, link }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Chia sẻ thiết kế
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TextField fullWidth value={link} InputProps={{ readOnly: true }} />
        <Tooltip title={copied ? "Đã sao chép" : "Sao chép"}>
          <IconButton onClick={handleCopy}>
            <ContentCopyIcon color={copied ? "success" : "primary"} />
          </IconButton>
        </Tooltip>
      </DialogContent>
    </Dialog>
  );
}

SharePopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  link: PropTypes.string.isRequired,
};

export default SharePopup;
